import React from 'react';
import NotesOverlayContainer from '../containers/notes/NotesOverlayContainer';
import PMOverlay from '../components/projectmanager/PMOverlay';
import PMTaskOverlay from '../components/projectmanager/new/PMTaskOverlay';

export const currentOverlaySwitch = (type) => {
	switch (type) {
		case 'notes':
			return <NotesOverlayContainer />;
		case 'pmEdit':
			return <PMOverlay />;
		case 'pmTaskEdit':
			return <PMTaskOverlay />;
		default:
			return null;
	}
}


// WEBPACK FOOTER //
// ./src/config/currentOverlaySwitch.js